module.exports = {
	customerBar: '107',
	customerList: '108',
	partnerList: 180,
	product: {
		bannerBar: 121,
	},
	home: {
		banner: 111,
		subBanner: 112,
		whyTencentCloud: 113,
		product: 114,
		solution: 115,
		certification: 116,
		customerBanner: 117,
		customerSubBanner: 118,
		v3Banner: 187,
		v3SubBanner: 186,
		v3WhyTencentCloud: 188,
		v3CustomerBanner: 189,
		v3CustomerSubBanner: 190,
		ableArea: 191,
		v3SolutionList: 192,
		v3ProductList: 193,
		v3ProductUpdate: 194,
		v3FooterStart: 195,
		v3BuyProduct: 196,
		v3BuyProductRule: 197,
		v3Activity: 198,
		v3TopAdvertising: 216
	},
	common: {
		footer: 119,
		phone: 151,
		avaliableRegionWorld: 120,
		avaliableRegionWorldV2: 127,
		menu: {
			solution: 168,
			solutionRec: 142,
			document: 143,
			documentRec: 144,
			support: 145,
			supportRec: 146,
			priceRec: 176,
			latestOffers: 207,
			prodHotRecommended: 211,
			prodSaleRecommended: 210,
			cookieList: 222,
			partners: 223,
			partnersRec: 226,
			exploreMore: 224,
			exploreMoreRec: 227,
		},
	},
	compliance: {
		global: 124,
		region: 125,
		personal: 126,
	},
	analyst: {
		reportList: 128,
	},
	infrastructure: {
		china: 	140,
		asia: 130,
		northAmerica: 132,
		southAmerica: 177,
		european: 133,
		RegionsLang: 137,
		regionsLangContent: 243,
		chinaNodes: 136,
		OverseasNodes: 135,
		FAQ: 134,
	},
	introduction: {
		footprint: 149,
		compliance: 147,
		customer: 148,
	},
	cloudMarket: {
		bars: 161,
		marketList: 162,
	},
	coupon: {
		couponInfo: 163,
		otherTips: 201,
		discountTips: 208,
		fullbackTips: 212,
	},
	activity: {
    	cps: 215,
		eduDetail: 236,
  	},
};